import { SettleSuitService } from './settleSuit'

import { AccountingPeriodService } from './accountingPeriod'

import { AccountSubjectService } from './accountSubject'

import { AuxiliaryAccountingService } from './auxiliaryAccounting'

import { ProofTemplateService } from './proofTemplate'

import { TemplateConfigService } from './templateConfig'

import { OrderService } from './order'

import { ExcelService } from './excel'

import { OutInBatchDetailService } from './outInBatchDetail'

import { SettleOrderConfigService } from './settleOrderConfig'

import { InvoiceService } from './invoice'

import { PaymentSettlementService } from './paymentSettlement'

import { InventoryCalculateService } from './inventoryCalculate'

import { RebateRuleService } from './rebateRule'
import { PaymentOughtService } from './paymentOught'

import { PaymentAdvanceService } from './paymentAdvance'

import { ProofPrepositionService } from './proofPreposition'

import { ProofService } from './proof'

import { CatalogService } from './catalog'

import { ProofSourceItemService } from './proofSourceItem'

export const settleOrderConfig = new SettleOrderConfigService('/api/settle/settleOrderConfig')

export const outInBatchDetail = new OutInBatchDetailService('/api/settle/outInBatchDetail')

export const excel = new ExcelService('/api/settle/excel')

export const order = new OrderService('/api/settle/order')

export const settleSuit = new SettleSuitService('/api/settle/settleSuit')

export const accountingPeriod = new AccountingPeriodService('/api/settle/accountingPeriod')

export const accountSubject = new AccountSubjectService('/api/settle/accountSubject')

export const auxiliaryAccounting = new AuxiliaryAccountingService('/api/settle/auxiliaryAccounting')

export const proofTemplate = new ProofTemplateService('/api/settle/proofTemplate')

export const templateConfig = new TemplateConfigService('/api/settle/templateConfig')

export const invoice = new InvoiceService('/api/settle/invoice')

export const paymentSettlement = new PaymentSettlementService('/api/settle/paymentSettlement')

export const inventoryCalculate = new InventoryCalculateService('/api/settle/inventoryCalculate')

export const rebateRule = new RebateRuleService('/api/settle/rebateRule')
export const paymentAdvance = new PaymentAdvanceService('/api/settle/paymentAdvance')

export const payment = new PaymentOughtService('/api/settle/paymentOught')

export const proofPreposition = new ProofPrepositionService('/api/settle/proofPreposition')

export const proof = new ProofService('/api/settle/proof')

export const proofSourceItem = new ProofSourceItemService('/api/settle/proofSourceItem')

export const catalog = new CatalogService('/api/settle/catalog')
